import type { TOC } from '@ember/component/template-only';

import CommonTypewriterComponent from 'webapp/components/common/typewriter';
import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

interface Args {
	messages: string[];
	intervalTime: number;
}

const MetricDetailsChartLoadingComponent: TOC<{ Args: Args }> = <template>
	<div class="status status--loading metric-details__chart-loading">
		<CommonTypewriterComponent @messages={{@messages}} @intervalTime={{@intervalTime}} />
		<SkeletonScreenComponent @type="graph" />
	</div>
</template>;

export default MetricDetailsChartLoadingComponent;
